import { createApp } from 'vue'
import router from '@/route'
import store from './store'
import App from '@/App.vue'
import VueWechatTitle from 'vue-wechat-title'

// import 'swiper/element/bundle'
// import { register } from 'swiper/element/bundle'
// register()

import './style/normal.css'
import './style/typography.css'
import './style/fonts.css'
import 'swiper/swiper.min.css'

import i18n from './i18n'

const app = createApp(App)

app.use(router).use(store).use(i18n).use(VueWechatTitle).mount('#app')
